import React from 'react'
import css from './style.css'

const HorizontalRule = props => {
  return (
    <div className={props.children ? css.title : css.line}>
      <span>{props.children}</span>
    </div>
  )
}

export default HorizontalRule



// WEBPACK FOOTER //
// ./src/components/horizontal-rule/index.js